import { render } from "./customizeItem.vue?vue&type=template&id=19cb4de8&scoped=true"
import script from "./customizeItem.vue?vue&type=script&lang=js"
export * from "./customizeItem.vue?vue&type=script&lang=js"

import "./customizeItem.vue?vue&type=style&index=0&id=19cb4de8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cb4de8"]])

export default __exports__